const getAuth = state => (state && state.auth) || {};
const getDataField = (state, fieldName) => getDataFields(state)[fieldName];
const getDataFields = state => getAuth(state).dataFields;
const getError = state => getAuth(state).error || false;
const getErrorType = state => getError(state).errorType || '';
const getLoginPopoverName = state => getAuth(state).loginPopoverName || '';
const getStopErrorResetPropagation = state => getAuth(state).stopErrorResetPropagation;
const isLoading = state => getAuth(state).loading;
const getFbAuthId = state => getAuth(state).fbAuthId || '';

export default {
    getDataField,
    getDataFields,
    getErrorType,
    getLoginPopoverName,
    getStopErrorResetPropagation,
    isLoading,
    getFbAuthId,
};
